import AnimatedLogo from 'components/Icons/AnimatedLogo'
import { useMemo, type CSSProperties } from 'react'
import './styles.scss'

interface LoadingProps {
  size?: 'small' | 'middle' | 'bigger' // spin size, optional. Default is "middle"
  colors?: Array<string> // spin colors, optional. Default is "#489E46" and "#276647"
  title?: string // title, optional. Default is null
  styles?: CSSProperties
}

function Loading({
  size = 'middle',
  colors = ['#276647', '#489E46'],
  title = '',
  styles = {},
}: LoadingProps) {
  const widthAndHeight: Record<'width' | 'height', string> = useMemo(() => {
    switch (size) {
      case 'small':
        return {
          width: '4rem',
          height: '4rem',
        }
      case 'middle':
        return {
          width: '7rem',
          height: '7rem',
        }
      default:
        return {
          width: '10rem',
          height: '10rem',
        }
    }
  }, [size])

  const styleTitle: CSSProperties = useMemo(() => {
    switch (size) {
      case 'small':
        return {
          font: `normal 1.3rem IBM Plex Sans, sans-serif`,
          color: colors[1],
        }
      case 'middle':
        return {
          font: `normal 1.5rem IBM Plex Sans, sans-serif`,
          color: colors[1],
        }
      default:
        return {
          font: `normal 1.7rem IBM Plex Sans, sans-serif`,
          color: colors[1],
        }
    }
  }, [])

  return (
    <div className="loading-container" style={styles}>
      <AnimatedLogo widthAndHeight={widthAndHeight} colors={colors} />
      <span style={styleTitle}>{title}</span>
    </div>
  )
}

export default Loading
